import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { ReactSparkConfirmationDialog } from '../../../widgets/index';
import * as ManageActions from '../../../../actions/manage';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { withRouter } from 'react-router';
import { ConfigurationService } from '../../../../services/ConfigurationService';
import { ThemeService } from '../../../../services/ThemeService';
import { ACCESS_POINT_LEVEL, ACCESS_POINTS_GROUP } from '../../../../constants/AccessPoints';
import { themeSystemDefault, configurationSystemDefault, sbemShadCNThemeDefault } from '../../../../constants/SystemDefaults';
import { CONTENT_CODE } from '../../../../constants/ContentCode';
import { LinkIcon } from '../../../assets/LinkIcon';
import { checkPermissions } from '../../../../../lib/utils';
import ReactSparkCogWheel from '../../../widgets/ReactSparkCogWheel';
import get from 'lodash/get';
import trim from 'lodash/trim';
import fileDownload from 'js-file-download';
import { filterThemeUniqueGlobal } from '../../../../constants/uniqueKeyToGlobalMap';
import { getCleanedThemeJson, getCleanedConfigJson } from '../utils';

const contenttypeServiceMap = {
    themes: ThemeService,
    configuration: ConfigurationService
};

class TableRow extends Component {
    constructor(props, context) {
        super(props);
        this.store = context.store;
        this.state = {
            openModal: false,
            activeState: this.props.item.IsActive
        };
        this.handleChange = this.handleChange.bind(this);
        this.setAsDefault = this.setAsDefault.bind(this);
    }

    handleChange(event) {
        this.setState({ activeState: !this.state.activeState });
        const { item, chain, hotel, contenttype } = this.props;
        const Service = contenttypeServiceMap[contenttype];
        const selectedLevel = this.store.getState().app.selected.level;
        Service.setActive(chain, hotel, item.ContentCode, this.state.activeState, selectedLevel);
    }

    setAsDefault(item) {
        this.store.dispatch(ManageActions.setDefaultTheme(item));
    }

    isInteractionAllowed(item) {
        return this.store.getState().app.selected.level === item.level;
    }

    shouldDisableButton(contentType, accessType = '', item, selectedLevel) {
        const accessLevels = _.get(this.props, `accessLevel.${contentType}`, []);
        if (_.indexOf(this.props.userPermissionLevels, selectedLevel) === -1) {
            return true;
        }

        // Disable edit button for SBEM themes
        if (item && item.isSbemTheme && accessType === ACCESS_POINT_LEVEL.EDIT) {
            return true;
        }

        if (item && item.ContentCode !== CONTENT_CODE.SYSTEM_DEFAULT && item.level !== selectedLevel) {
            if (accessType === ACCESS_POINT_LEVEL.ADD && accessLevels.includes(accessType)) {
                return false;
            }
            return true;
        } else {
            if (item.ContentCode === CONTENT_CODE.SYSTEM_DEFAULT && accessType !== ACCESS_POINT_LEVEL.ADD) {
                return true;
            } else if (accessType === ACCESS_POINT_LEVEL.VIEW && accessLevels.includes(ACCESS_POINT_LEVEL.EDIT)) {
                return false;
            }
            return !accessLevels.includes(accessType);
        }
    }

    getDropdownOptions(accessLevels, chain, hotel, contentCode, itemLevel, service, item)  {
        const isDownloadFileAllowed = accessLevels.downloadAllowed;
        const isEditFileAllowed = accessLevels.allowEdit;
        const isDeleteFileAllowed = accessLevels.allowDelete;
        const category = this.props.category ? this.props.category : 'SBE';
        return (
            <ul className="spark-toolbar__list spark-toolbar__item--close-on-click">
                {isDownloadFileAllowed && (
                    <li
                        tabIndex="0"
                        onClick={() => {
                            if (_.isEqual(contentCode, 'systemdefault')) {
                                if (this.props.itemName === 'Theme') {
                                    const systemDefaultTheme = filterThemeUniqueGlobal(themeSystemDefault);
                                    const cleanedThemeJson = getCleanedThemeJson(systemDefaultTheme);
                                    fileDownload(JSON.stringify(cleanedThemeJson), `systemDefault.json`);
                                } else if (this.props.itemName === 'Configuration') {
                                    fileDownload(JSON.stringify(configurationSystemDefault), `systemDefault.json`);
                                }
                            } else if (_.isEqual(contentCode, 'systemdefault-sbem')) {
                                fileDownload(JSON.stringify(sbemShadCNThemeDefault), `systemDefault-sbem.json`);
                            } else {
                                service.get(chain, hotel, contentCode, itemLevel, category).then(response => {
                                    const jsonFromResponse = get(response, 'data.BEDesignerResult.Value.Data');
                                    const jsonName =
                                        trim(get(response, 'data.BEDesignerResult.ContentName')) || this.props.itemName;
                                    const filename = `${jsonName}.json`;
                                    if (this.props.itemName === 'Theme') {
                                        if (category === 'SBEM') {
                                            fileDownload(JSON.stringify(jsonFromResponse), filename);
                                        } else {
                                            const cleanedThemeJson = getCleanedThemeJson(jsonFromResponse);
                                            fileDownload(JSON.stringify(cleanedThemeJson), filename);
                                        }
                                    } else if (this.props.itemName === 'Configuration') {
                                        const cleanedConfigJson = getCleanedConfigJson(jsonFromResponse);
                                        fileDownload(JSON.stringify(cleanedConfigJson), filename);
                                    }
                                });
                            }
                        }}
                    >
                        Download {this.props.itemName} File
                    </li>
                )}
                {isEditFileAllowed && (
                    <li
                        tabIndex="0"
                        onClick={() => {
                            const category = item.isSbemTheme ? 'SBEM' : 'SBE';
                            service.get(chain, hotel, contentCode, itemLevel, category).then(response => {
                                const jsonFromResponse = get(response, 'data.BEDesignerResult.Value.Data');
                                if (this.props.itemName === 'Theme') {
                                    const cleanedThemeJson = getCleanedThemeJson(jsonFromResponse);
                                    this.props.setData(cleanedThemeJson, response.data.BEDesignerResult.ContentCode, item.isSbemTheme);
                                } else if (this.props.itemName === 'Configuration') {
                                    const cleanedConfigJson = getCleanedConfigJson(jsonFromResponse);
                                    this.props.setData(cleanedConfigJson, response.data.BEDesignerResult.ContentCode, item.isSbemTheme);
                                }
                                this.props.router.push(`/manage/${this.props.uploadUrl}`);
                            });
                        }}
                    >
                        Edit {this.props.itemName} File
                    </li>
                )}
                {isDeleteFileAllowed && (
                    <li tabIndex="0" onClick={() => this.setState({ openModal: true })}>
                        Delete {this.props.itemName}
                    </li>
                )}
            </ul>
        );
    }

    render() {
        let { item } = this.props;
        const date = new Date(item.MetaData.Timestamp);
        const dateString = moment.utc(item.MetaData.Timestamp).format('MM/DD/YYYY');
        const dateHour = moment.utc(item.MetaData.Timestamp).format('HH:mm');
        const convertedDate = date.toDateString();
        const { chain, hotel, contenttype, category } = this.props;
        const Service = contenttypeServiceMap[contenttype];
        const selectedLevel = this.store.getState().app.selected.level;
        const accessLevels = _.get(this.props, `accessLevel.${contenttype}`, []);

        // const allowDownload = accessLevels.includes(ACCESS_POINT_LEVEL.EDIT) || accessLevels.includes(ACCESS_POINT_LEVEL.VIEW);
        const allowDownload = this.props.permissionTheme.edit || this.props.permissionTheme.view;
        const viewBtnDisabled = this.shouldDisableButton(contenttype, ACCESS_POINT_LEVEL.VIEW, item, selectedLevel);
        const copyBtnDisabled = this.shouldDisableButton(contenttype, ACCESS_POINT_LEVEL.ADD, item, selectedLevel);
        const editBtnDisabled = this.shouldDisableButton(contenttype, ACCESS_POINT_LEVEL.EDIT, item, selectedLevel);
        const deleteBtnDisabled = this.shouldDisableButton(contenttype, ACCESS_POINT_LEVEL.DELETE, item, selectedLevel);

        return (
            <tr>
                <td>
                    {
                        {
                            [SAVE_LEVEL.HOTEL]: 'HOTEL',
                            [SAVE_LEVEL.CHAIN]: 'CHAIN',
                            [SAVE_LEVEL.SYSTEM]: 'SYSTEM'
                        }[item.level]
                    }
                </td>
                <td>{item.MetaData.Name}</td>
                <td>{item.ContentCode}</td>
                <td>
                    <time dateTime={convertedDate} style={{ marginRight: '10px' }}>
                        {dateString}
                    </time>
                    <time>{dateHour}</time>
                </td>
                <td>
                    {/* <ReactSparkCheckbox status={item.IsActive} isDefault={item.ContentCode === this.props.defaultContentCode} onChange={this.handleChange} /> */}
                    {this.isInteractionAllowed(item) && (
                        <a
                            disabled={item.ContentCode === CONTENT_CODE.SYSTEM_DEFAULT || (item.isSbemTheme === false && editBtnDisabled)}
                            onClick={() => {
                                const category = item.isSbemTheme ? 'SBEM' : 'SBE';
                                Service.setActive(chain, hotel, item.ContentCode, !item.IsActive, item.level, category).then(() =>
                                    Service.reload(chain, hotel, selectedLevel)
                                );
                            }}
                        >
                            {`${item.IsActive ? 'Active' : 'Inactive'}`}
                        </a>
                    )}
                </td>
                <td>
                    {this.isInteractionAllowed(item) &&
                        (() => {
                            const relevantDefault =
                                contenttype === 'configuration'
                                    ? this.props.defaultContentConfig
                                    : item.isSbemTheme
                                        ? this.props.defaultContentSbem
                                        : this.props.defaultContent;
                            const isCurrentDefault = relevantDefault && item.ContentCode === relevantDefault.code;
                            
                            return isCurrentDefault ? (
                                <span className="btn-manage--default">
                                    <i className="check spark-icon--md" />
                                    {'Default'}
                                </span>
                            ) : (
                                <a
                                    disabled={item.isSbemTheme ? false : editBtnDisabled}
                                    onClick={() => {
                                        if (item.isSbemTheme) {
                                            Service.setAsDefault(chain, hotel, item.ContentCode, item.level, 'SBEM').then(() =>
                                                Service.reload(chain, hotel, selectedLevel)
                                            );
                                        } else {
                                            Service.setAsDefault(chain, hotel, item.ContentCode, item.level).then(() =>
                                                Service.reload(chain, hotel, selectedLevel)
                                            );
                                        }
                                    }}
                                >
                                    Set as Default
                                </a>
                            );
                        })()}
                    {(() => {
                        // Show system default indicators for configurations and themes
                        const relevantDefault =
                            contenttype === 'configuration'
                                ? this.props.defaultContentConfig
                                : item.isSbemTheme
                                    ? this.props.defaultContentSbem
                                    : this.props.defaultContent;
                        return relevantDefault && relevantDefault.level === SAVE_LEVEL.SYSTEM &&
                            item.ContentCode === relevantDefault.code && (
                                <span>
                                    <i className="check spark-icon--md" />
                                    {'Default'}
                                </span>
                            );
                    })()}
                </td>
                <td>
                    <div className="manage-actions-icons">
                        <LinkIcon
                            iconType="spark-icon-info-circle"
                            showTooltip={true}
                            disable={viewBtnDisabled}
                            onClick={() => {
                                const category = item.isSbemTheme ? 'SBEM' : 'SBE';
                                Service.all(chain, hotel, item.ContentCode, item.level, category).then(response => {
                                    this.props.onShowInfo(response.data.BEDesignerResult);
                                });
                            }}
                        />
                        <LinkIcon
                            iconType={
                                accessLevels.includes(ACCESS_POINT_LEVEL.EDIT)
                                    ? 'spark-icon-pencil'
                                    : 'spark-icon-password-view'
                            }
                            showTooltip={true}
                            disable={viewBtnDisabled}
                            link="/${contentType}"
                            onClick={() => {
                                const category = item.isSbemTheme ? 'SBEM' : 'SBE';
                                Service.get(chain, hotel, item.ContentCode, item.level, category).then(response => {
                                    this.props.setData(
                                        response.data.BEDesignerResult.Value.Data,
                                        response.data.BEDesignerResult.ContentCode,
                                        item.isSbemTheme
                                    );
                                    if (contenttype === 'configuration') {
                                        this.props.router.push('/pages');
                                    } else {
                                        if (this.props.permissionTheme.view || this.props.permissionTheme.edit) {
                                            this.props.router.push('/theme/colors');
                                        } else if (
                                            this.props.permissionCustomContent.view ||
                                            this.props.permissionCustomContent.edit
                                        ) {
                                            this.props.router.push('/theme/customContent');
                                        } else {
                                            this.props.router.push('/theme');
                                        }
                                    }
                                });
                            }}
                        />
                        <LinkIcon
                            iconType="spark-icon-documents"
                            showTooltip={true}
                            disable={copyBtnDisabled}
                            onClick={event => this.props.onCopy(item, event)}
                        />
                        <ReactSparkConfirmationDialog
                            open={this.state.openModal}
                            headLine="Delete?"
                            message={`This will Delete the ${this.props.itemName} '${item.ContentCode}' permanently. Do you want to proceed?`}
                            onPrimaryClick={() => {
                                if (item.isSbemTheme) {
                                    Service.delete(chain, hotel, item.ContentCode, item.level, 'SBEM').then(() =>
                                        Service.reload(chain, hotel, selectedLevel)
                                    );
                                } else {
                                    Service.delete(chain, hotel, item.ContentCode, item.level).then(() =>
                                        Service.reload(chain, hotel, selectedLevel)
                                    );
                                }
                                this.store.dispatch(ManageActions.deleteElement(item));
                                this.setState({ ...this.state, openModal: false });
                            }}
                            onSecondaryClick={() => this.setState({ ...this.state, openModal: false })}
                        />
                        {(allowDownload || !editBtnDisabled || !deleteBtnDisabled) && (
                            <ReactSparkCogWheel
                                dropdownOptions={this.getDropdownOptions(
                                    {
                                        downloadAllowed: allowDownload,
                                        allowEdit: !editBtnDisabled,
                                        allowDelete: !deleteBtnDisabled
                                    },
                                    chain,
                                    hotel,
                                    item.ContentCode,
                                    item.level,
                                    Service,
                                    item
                                )}
                            />
                        )}
                    </div>
                </td>
            </tr>
        );
    }
}

TableRow.propTypes = {
    category: PropTypes.string,
    item: PropTypes.object,
    onShowInfo: PropTypes.func,
    onCopy: PropTypes.func,
    accessLevel: PropTypes.object,
    contenttype: PropTypes.string,
    uploadUrl: PropTypes.string,
    itemName: PropTypes.string,
    userPermissionLevels: PropTypes.array
};

TableRow.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => {
    return {
        accessLevel: state.oauth.accessLevel,
        userPermissionLevels: state.oauth.userPermissionLevels,
        permissionTheme: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        permissionCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS),
        defaultContent: state.app.selected.defaultContent,
        defaultContentSbem: state.app.selected.defaultContentSbem,
        defaultContentConfig: state.app.selected.defaultContentConfig
    };
};

export default connect(mapStateToProps)(withRouter(TableRow));



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/TableRow.js